module.exports = __webpack_public_path__ + "static/media/smartphone.c37bab61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/smartphone.svg
// module id = ./src/resources/images/icons/smartphone.svg
// module chunks = 0